import { render, staticRenderFns } from "./TypeChecklistItemDialog.vue?vue&type=template&id=6c6d73fc&"
import script from "./TypeChecklistItemDialog.vue?vue&type=script&lang=js&"
export * from "./TypeChecklistItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports